module.exports = __webpack_public_path__ + "assets/img/Type E (75).48bc71b7.jpg";